export const APP_PATHS = {
  home: '/',
  activate: '/activate',
  signin: '/signin',
  pendingActivation: '/pending-activation',
  recoverAccount: '/recover-account',
  overview: '/overview',
  services: '/services',
  wholesalerSettings: '/wholesaler-settings',
  billing: '/billing',
  team: '/team',
  adminSettings: '/admin-settings',
  // A child route rather than a tab, so it needs its own entry to pass `validatePath`.
  adminSettingsApiKeys: '/admin-settings/api-keys-admin',
  setup: '/setup',
} as const;

type ValueOf<T> = T[keyof T];

export type AppPath = ValueOf<typeof APP_PATHS>;
export type ValidAppPath = AppPath;

const validAppPathValues = Object.values(APP_PATHS);

const VALID_APP_PATHS = new Set<ValidAppPath>(validAppPathValues as ValidAppPath[]);

export const isValidAppPath = (path: string): path is ValidAppPath => {
  return VALID_APP_PATHS.has(path as ValidAppPath);
};

export const assertValidAppPath = (path: string): ValidAppPath => {
  if (!isValidAppPath(path)) {
    throw new Error(`Invalid app path: ${path}`);
  }

  return path;
};
